<template>
  <b-form ref="selectableForm">
    <b-container v-if="noErrorsArray" ref="alertModal">
      <b-row>
        <b-col>
          <b-alert
              v-if="errors.length > 0"
              show
              variant="danger"
          >
            <li class="no-list-style" v-for="(error,index) in hasErrors" :key="index">
              <span v-html="getValidationsErrors(index, error)"></span>
            </li>
          </b-alert>
        </b-col>
      </b-row>
    </b-container>
    <b-container v-if="hasWarningError.length > 0" ref="warningModal">
      <b-row>
        <b-col>
          <b-alert
              show
              variant="warning"
          >
            <span>{{ hasWarningError[0] }}</span>
          </b-alert>
        </b-col>
      </b-row>
    </b-container>
    <b-row>
      <template v-for="(field,index) in tableFields">
        <template v-if="Object.prototype.hasOwnProperty.call(field, 'formView') ? field.formView === true : true">
          <b-col :key="field.key + index" :cols="field.cols !== undefined ? field.cols - columnSize : columnSize"
                 :sm="field.sm !== undefined ? field.sm - columnSize : columnSize"
                 :md="field.md !== undefined ? field.md - columnSize : columnSize">
            <b-form-group v-if="field.component === 'b-form-input'" :id="field.key + '-input-group'"
                          :label="field.label" :label-for="field.key + '-form-input'" style="font-weight:bold">
              <b-form-input :id="field.key + '-form-input'" :name="field.key + '-form-input'"              
                            :placeholder="field.placeholder"
                            v-model.lazy="$v.form[field.key].$model"
                            :aria-describedby="field.key + '-input-live-feedback'"
                            :disabled="Boolean(field.disabled)"
                            :state="validateState(field.key)"
                            lazy-formatter
                            :formatter="Object.prototype.hasOwnProperty.call(field, 'formatter') ? field.formatter : null"
                            :maxLength="Object.prototype.hasOwnProperty.call(field, 'maxLength') ? field.maxLength : null"
                            trim
                            :style="Object.prototype.hasOwnProperty.call(field, 'formatter') ? 'text-transform: uppercase' : ''"
                            size="md"
              />
              <b-tooltip v-if="Object.prototype.hasOwnProperty.call(field, 'tooltip')"
                         :target="field.key + '-form-input'" triggers="hover" placement="topright">
                <td v-html="field.tooltip"></td>
              </b-tooltip>
              <template v-if="Object.prototype.hasOwnProperty.call(field, 'required')"
                        #label>
                <span v-if="field.required($v.form)" class="required"><strong>* </strong></span> <span
                  v-html="field.label"/>
              </template>
              <b-form-text v-if="Object.prototype.hasOwnProperty.call(field, 'helper')" :id="field.key + '-help-block'">
                {{ field.helper }}
              </b-form-text>
            </b-form-group>

            <b-form-group v-if="field.component === 'b-form-file'" :id="field.key + '-file-group'"
                          :label="field.label" :label-for="field.key + '-file-input'" style="font-weight:bold">
              <b-form-file :id="field.key + '-file-input'" :name="field.key + '-file-input'"
                           browse-text="φόρτωση εγγράφου"
                           v-model.lazy="$v.form[field.key].$model"
                           :aria-describedby="field.key + '-file-live-feedback'"
                           :disabled="Boolean(field.disabled)"
                           :state="validateState(field.key)"
                           :placeholder="field.placeholder"
                           :accept="field?.accept ?? 'image/bmp, image/x-windows-bmp, image/gif, image/jpeg, image/pjpeg, image/x-portable-bitmap, image/png, image/tiff, image/x-tiff, application/pdf, text/plain, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/excel, application/vnd.ms-excel, application/x-excel, application/x-msexcel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, docx, xlsx'"
                           :style="Object.prototype.hasOwnProperty.call(field, 'formatter') ? 'text-transform: uppercase' : ''"
                           size="md"
              >
                <template slot="file-name" slot-scope="{ names }">
                  <b-badge class="p-1" style="background-color: #9e9e9e;">{{ names[0] }}</b-badge>
                  <b-badge v-if="names.length > 1" style="background-color: #9e9e9e" class="ml-1">
                    + {{ names.length - 1 }} More files
                  </b-badge>
                </template>
              </b-form-file>
              <b-tooltip v-if="Object.prototype.hasOwnProperty.call(field, 'tooltip')"
                         :target="field.key + '-file-input'" triggers="hover" placement="topright">
                <td v-html="field.tooltip"></td>
              </b-tooltip>
              <template v-if="Object.prototype.hasOwnProperty.call(field, 'required')"
                        #label>
                <span v-if="field.required($v.form)" class="required"><strong>* </strong></span> <span
                  v-html="field.label"/>
              </template>
              <b-form-text v-if="Object.prototype.hasOwnProperty.call(field, 'helper')" :id="field.key + '-help-block'">
                {{ field.helper }}
              </b-form-text>
            </b-form-group>

            <b-form-group v-if="field.component === 'b-form-textarea'" :id="field.key + '-textarea-group'"
                          :label="field.label" :label-for="field.key + '-textarea-input'" style="font-weight:bold">
              <b-form-textarea :id="field.key + '-textarea-input'"
                               :name="field.key + '-textarea-input'"
                               v-model.lazy="$v.form[field.key].$model"
                               :disabled="Boolean(field.disabled)"
                               :state="validateState(field.key)"
                               rows="3"
                               max-rows="10"
                               :aria-describedby="field.key + '-textarea-live-feedback'"
                               :maxLength="Object.prototype.hasOwnProperty.call(field, 'maxLength') ? field.maxLength : null"
                               trim
                               size="md"/>
              <b-tooltip v-if="Object.prototype.hasOwnProperty.call(field, 'tooltip')"
                         :target="field.key + '-textarea-input'" triggers="hover" placement="topright">
                <td v-html="field.tooltip"></td>
              </b-tooltip>
              <template v-if="Object.prototype.hasOwnProperty.call(field, 'required')"
                        #label>
                <span v-if="field.required($v.form)" class="required"><strong>* </strong></span><span
                  v-html="field.label"/>
              </template>
              <b-form-text v-if="Object.prototype.hasOwnProperty.call(field, 'helper')" :id="field.key + '-help-block'">
                {{ field.helper }}
              </b-form-text>
            </b-form-group>

            <b-form-group v-if="field.component === 'b-form-datepicker'" :id="field.key + '-datepicker-group'"
                          :label="field.label" :label-for="field.key + '-datepicker-input'" style="font-weight:bold">
              <b-input-group>
                <b-form-input
                    :id="field.key + '-datepicker-form-input'"
                    v-model.lazy="$v.form[field.key].$model"
                    :value="onValue(field.key)"
                    type="text"
                    :placeholder="Object.prototype.hasOwnProperty.call(field, 'placeholder') ? field.placeholder : 'DD/MM/YYYY'"
                    :state="validateState(field.key)"
                    :formatter="validDateFormat"
                    :maxLength="Object.prototype.hasOwnProperty.call(field, 'maxLength') ? field.maxLength : null"
                    :disabled="Boolean(field.disabled)"
                    @input="onInput($v.form[field.key],field)"
                    autocomplete="off"
                    trim
                    size="md">
                </b-form-input>
                <b-input-group-append>
                  <b-form-datepicker
                      :id="field.key + '-datepicker-input'"
                      :name="field.key + '-datepicker-input'"
                      v-model.lazy="selectedDate"
                      :aria-controls="field.key"
                      :aria-describedby="field.key + '-datepicker-live-feedback'"
                      :maxLength="Object.prototype.hasOwnProperty.call(field, 'maxLength') ? field.maxLength : null"
                      :date-format-options="{ month: 'numeric', day: 'numeric', year: 'numeric' }"
                      :disabled="Boolean(field.disabled)"
                      @hidden="onHidden(field.key)"
                      @shown="onShown(field.key)"
                      v-bind="labels.el || {}"
                      locale="el"
                      button-only
                      today-button
                      reset-button
                      close-button
                      right
                      hide-header
                      block
                      size="md"
                  />
                </b-input-group-append>
                <b-tooltip v-if="Object.prototype.hasOwnProperty.call(field, 'tooltip')"
                           :target="field.key + '-datepicker-input'" triggers="hover" placement="topright">
                  <td v-html="field.tooltip"></td>
                </b-tooltip>
                <b-tooltip v-if="Object.prototype.hasOwnProperty.call(field, 'tooltip')"
                           :target="field.key + '-datepicker-form-input'" placement="topright">
                  <td v-html="field.tooltip"></td>
                </b-tooltip>
              </b-input-group>
              <template v-if="Object.prototype.hasOwnProperty.call(field, 'required')"
                        #label>
                <span v-if="field.required($v.form)" class="required"><strong>* </strong></span><span
                  v-html="field.label"/>
              </template>
              <b-form-text v-if="Object.prototype.hasOwnProperty.call(field, 'helper')" :id="field.key + '-help-block'">
                {{ field.helper }}
              </b-form-text>
            </b-form-group>

            <b-form-group v-if="field.component === 'b-form-select-datalist'" :id="field.key+'-select-group'"
                          :label="field.label"
                          :label-for="field.key+'-select-datalist-input'" style="font-weight:bold">
              <v-select
                  :class="!isEmpty(validateState(field.key)) ? 'vs--searchable_danger' : ''"
                  :id="field.key+'-select-input'"
                  v-model.lazy="$v.form[field.key].$model"
                  :reduce="value =>value.value"
                  :options="field.options"
                  :disabled="Boolean(field.disabled)"
                  label="text"
                  @close="onChange($v.form[field.key],field)"
              />
              <b-tooltip v-if="Object.prototype.hasOwnProperty.call(field, 'tooltip')"
                         :target="field.key + '-select-input'" placement="topright">
                <td v-html="field.tooltip"></td>
              </b-tooltip>
              <template v-if="Object.prototype.hasOwnProperty.call(field, 'required')"
                        #label>
                <span v-if="field.required($v.form)" class="required"><strong>* </strong></span><span
                  v-html="field.label"/>
              </template>
              <b-form-text v-if="Object.prototype.hasOwnProperty.call(field, 'helper')" :id="field.key + '-help-block'">
                {{ field.helper }}
              </b-form-text>
            </b-form-group>

            <b-form-group v-if="field.component === 'b-form-select'" :id="field.key+'-select-group'"
                          :label="field.label"
                          :label-for="field.key+'-select-input'" style="font-weight:bold">
              <b-form-select
                  :id="field.key+'-select-input'"
                  :name="field.key+'-select-input'"
                  v-model.lazy="$v.form[field.key].$model"
                  :state="validateState(field.key)"
                  :aria-describedby="field.key+'-select-live-feedback'"
                  @input="onChange($v.form[field.key],field)"
                  :disabled="Boolean(field.disabled)"
                  size="md"
              >
                <template v-for="(option,index) in field.options">
                  <b-form-select-option :key="index" :value="option.value">
                    {{ option.text }}
                  </b-form-select-option>
                </template>
              </b-form-select>
              <b-tooltip v-if="Object.prototype.hasOwnProperty.call(field, 'tooltip')"
                         :target="field.key + '-select-input'" placement="topright">
                <td v-html="field.tooltip"></td>
              </b-tooltip>
              <template v-if="Object.prototype.hasOwnProperty.call(field, 'required')"
                        #label>
                <span v-if="field.required($v.form)" class="required"><strong>* </strong></span><span
                  v-html="field.label"/>
              </template>
              <b-form-text v-if="Object.prototype.hasOwnProperty.call(field, 'helper')" :id="field.key + '-help-block'">
                {{ field.helper }}
              </b-form-text>
            </b-form-group>
            <b-form-group v-if="field.component === 'b-form-select-tree'" :id="field.key+'-select-tree-group'"
                          :label="field.label"
                          :label-for="field.key+'-select-tree-input'" style="font-weight:bold">
              <Treeselect
                  ref="treeSelect"
                  :id="field.key+'-select-tree-input'"
                  v-model="$v.form[field.key].$model"
                  :closeOnSelect=true
                  @input="onChangeTree($v.form[field.key])"
                  :allowClearingDisabled="true"
                  :allowSelectingDisabledDescendants="true"
                  :autoDeselectAncestors=true
                  :autoSelectAncestors=true
                  :multiple="true"
                  :flat="true"
                  :show-count="true"
                  :beforeClearAll="beforeClearAll"
                  @select="selected"
                  @open="open"
                  valueFormat="object"
                  valueConsistsOf="ALL_WITH_INDETERMINATE"
                  :options="initOptions(field.options)">
                <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                       :class="labelClassName">
                  {{ node.isBranch ? node.label : node.label + ' (Τελική Ιδιότητα)' }}
                  <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                </label>
              </Treeselect>
              <b-tooltip v-if="Object.prototype.hasOwnProperty.call(field, 'tooltip')"
                         :target="field.key + '-select-tree-input'" placement="topright">
                <td v-html="field.tooltip"></td>
              </b-tooltip>
              <template v-if="Object.prototype.hasOwnProperty.call(field, 'required')"
                        #label>
                <span v-if="field.required($v.form)" class="required"><strong>* </strong></span><span
                  v-html="field.label"/>
              </template>
              <b-form-text v-if="Object.prototype.hasOwnProperty.call(field, 'helper')" :id="field.key + '-help-block'">
                {{ field.helper }}
              </b-form-text>
            </b-form-group>
            <b-form-group v-if="field.component === 'b-form-radio-group'" :id="field.key + '-radio-group'"
                          :label="field.label" :label-for="field.key + '-radio-input'" style="font-weight:bold">
              <b-form-radio-group :id="field.key + '-radio-input'"
                                  :name="field.key + '-radio-input'"
                                  v-model.lazy="$v.form[field.key].$model"
                                  :options=field.options
                                  :state="validateState(field.key)"
                                  :aria-describedby="field.key + '-radio-live-feedback'"
                                  @input="onInput($v.form[field.key], field)"
                                  :disabled="Boolean(field.disabled)"
                                  size="md"/>

              <b-tooltip v-if="Object.prototype.hasOwnProperty.call(field, 'tooltip')"
                         :target="field.key + '-radio-input'" triggers="hover" placement="topright">
                <td v-html="field.tooltip"></td>
              </b-tooltip>
              <template v-if="Object.prototype.hasOwnProperty.call(field, 'required')"
                        #label>
                <span v-if="field.required($v.form)" class="required"><strong>* </strong></span><span
                  v-html="field.label"/>
              </template>
              <b-form-text v-if="Object.prototype.hasOwnProperty.call(field, 'helper')" :id="field.key + '-help-block'">
                {{ field.helper }}
              </b-form-text>
            </b-form-group>

            <b-form-group v-if="field.component === 'b-form-checkbox'" :id="field.key + '-checkbox-group'"
                          style="font-weight:bold">
              <span v-if="field.hasTitle" class="title"> {{ field.title }}</span>
              <br v-if="field.hasTitle && field.hasSubTitle"/>
              <span v-if="field.hasSubTitle" class="subTitle">{{ field.subTitle }} </span>
              <b-form-checkbox
                  :key="field.key + '-checkbox-input' + index"
                  :id="field.key + '-checkbox-input'"
                  :name="field.key + '-checkbox-input'"
                  v-model.lazy="$v.form[field.key].$model"
                  :state="validateState(field.key)"
                  :aria-describedby="field.key + '-checkbox-live-feedback'" value="1"
                  unchecked-value="not_accepted"
                  @input="onInput($v.form[field.key], field)"
                  :disabled="Boolean(field.disabled)"
                  size="md">
                {{ field.label }}
              </b-form-checkbox>
              <b-tooltip v-if="Object.prototype.hasOwnProperty.call(field, 'tooltip')"
                         :target="field.key + '-checkbox-input'" triggers="hover" placement="topright">
                <td v-html="field.tooltip"></td>
              </b-tooltip>
              <template v-if="Object.prototype.hasOwnProperty.call(field, 'required')"
                        #label>
                <span v-if="field.required($v.form)" class="required"><strong>* </strong></span>
              </template>
              <b-form-text v-if="Object.prototype.hasOwnProperty.call(field, 'helper')" :id="field.key + '-help-block'">
                {{ field.helper }}
              </b-form-text>
              <span
                  v-if="field.hasHelperError && ($v.form[field.key].$model == true) && !isEmpty($v.form[field.key].$model)"
                  class="hasHelperError">{{ field.hasHelperError }} </span>
            </b-form-group>
          </b-col>
        </template>
      </template>
    </b-row>
  </b-form>
</template>

<script>

import {validationHandler} from "@/util/ValidationErrors";
import {validationMixin} from "vuelidate";
import store from "@/store";
import {formatDateGRDefault, formatDateUTCDefault, formatDateWithFormat} from "@/util/DateUtil";
import {getCaption, isEmpty} from "@/util/Helpers";
import Treeselect from "@riophae/vue-treeselect";
import {makeToast} from "@/util/ComponentUtils";

export default {
  name: "BaseBForm",
  components: {Treeselect},
  mixins: [validationMixin],
  validations() {
    return {
      form: !isEmpty(this.modelC.validations) ? this.modelC.validations.form : {}
    }
  },
  props: {
    model: Object,
    noErrorsArray: {
      default: true,
      require: false,
      type: Boolean
    },
    formTitle: {
      default: 'Φόρμα',
      require: true,
      type: String
    },
    columnSize: {
      default: 4,
      require: true,
      type: Number
    }
  },
  data() {
    return {
      hasErrors: [],
      hasWarningError: [],
      form: this.model.form,
      validTes: this.model.form,
      OPEN: 1,
      CLOSED: 2,
      firstChange: true,
      options: [],
      formatted: '',
      selectedDate: '',
      labels: {
        el: {
          labelPrevDecade: 'Προηγούμενο',
          labelPrevYear: 'Προηγούμενος χρόνος',
          labelPrevMonth: 'Προηγούμενος μήνας',
          labelCurrentMonth: 'Τρέχον μήνας',
          labelNextMonth: 'Επόμενος μήνας',
          labelNextYear: 'Επόμενο έτος',
          labelTodayButton: 'Σήμερα',
          labelResetButton: 'Καθαρισμός',
          labelCloseButton: 'Κλείσιμο',
          labelNextDecade: 'Nächstes Jahrzehnt',
          labelToday: 'Heute',
          labelSelected: 'Ausgewähltes Datum',
          labelNoDateSelected: 'Δεν έχει επιλεχθεί ημ/νία',
          labelCalendar: 'Kalender',
          // labelNav: 'Kalendernavigation',
          labelHelp: 'Χρησιμοποιήστε τα πλήκτρα κέρσορα για πλοήγηση στις ημερομηνίες του ημερολογίου'
        },
      }
    }
  },
  watch: {
    options(curr, prev) {
      return curr
    }
  },
  computed: {
    errors() {
      return this.hasErrors
    },
    modelC() {
      return this.model
    },
    tableFields: {
      get() {
        return this.modelC.fields
      },
      set(val) {
        this.$emit('onChange', val);
      }
    }
  },
  created() {
    this.setWarningError()
    this.validateForm()
  },

  methods: {
    open(instanceId) {
      if (!isEmpty(this.$v.form['idiothtaTree'])) {
        this.$v.form['idiothtaTree'].$model = []
      }
      if (!isEmpty(this.options)) {
        this.options.map(x => {
          x.isDisabled = false
          if (Object.prototype.hasOwnProperty.call(x, 'children')) {
            x.children.forEach(y => {
              y.isDisabled = false
              if (Object.prototype.hasOwnProperty.call(y, 'children')) {
                y.children.forEach(x2 => {
                  x2.isDisabled = false
                })
              }
            })
          }
        })
      }
    },
    initOptions(options) {
      this.options = options
      return this.options
    },
    onChangeTree(value) {
      if (!isEmpty(value.$model)) {
        let data = value.$model[0]
        if (Object.prototype.hasOwnProperty.call(data, 'children')) {
          value.$model = null
          makeToast(this, getCaption('WARNING_LABEL_DPK_IDIOTHTES_SEARCH'), 'warning', 'Ενημερωτικό μήνυμα')
          return value.$model
        } else {
          let data = this.$v.form.$model
          let parentId = null
          let size = data.idiothtaTree.length
          data.idiothtaTree.slice().reverse().forEach((row, index) => {
            if (index === 0) {
              parentId = null
              data.idiothta = store.getters["lookups/getIdiothta"].filter(x => {
                if (x.value !== null) {
                  if (!isEmpty(x.value)) {
                    {
                      if (x.value.t048Id === row.id) {
                        return x
                      }
                    }
                  }
                }
              })[0].value
              let item = this.tableFields.filter(row => row.key === 'idiothta')[0]
              this.onChange(this.$v.form['idiothta'].$model, item)
            } else {
              this.$v.form['idiothta' + index].$model = store.getters["lookups/getIdiothta"].filter(x => {
                if (x.value !== null) {
                  if (!isEmpty(x.value)) {
                    {
                      if (x.value.t048Id === row.id) {
                        if (Object.prototype.hasOwnProperty.call(x.value, 'parentId')) {
                          parentId = x.value.parentId
                        } else {
                          parentId = null
                        }
                        return x
                      }
                    }
                  }
                }
              })[0].value
              let options = store.getters["lookups/getIdiothta"].filter(x => {
                if (x.value !== null) {
                  if (!isEmpty(x.value) && !isEmpty(row)) {
                    {
                      if (x.value.t048Id !== undefined && x.value.parentId === parentId)
                        return x
                    }
                  }
                }
              })
              let item = this.tableFields.filter(row => {
                if (row.key === 'idiothta' + index) {
                  row.options = options
                  row.disabled = false
                  return row
                }
              })[0]
              this.onChange(this.$v.form['idiothta' + index].$model, item)
              if (index === (size - 1)) {
                this.$v.form['idiothtaT048'].$model = this.$v.form['idiothta' + index].$model
              }
            }
          })
        }
      }
    },
    beforeClearAll() {
      let data = this.$v.form.$model
      data.idiothtaTree.slice().reverse().forEach((row, index) => {
        if (index !== 0) {
          this.tableFields.map(row => {
            if (row.key === 'idiothta' + index) {
              row.options = []
              row.disabled = true
              row.required = () => false
            }
          })
          this.$v.form['idiothta' + index].$model = null
        } else {
          this.$v.form['idiothta'].$model = null
        }
      })
      this.options.map(x => {
        if (Object.prototype.hasOwnProperty.call(x, 'children')) {
          x.isDisabled = false
          x.children.forEach(x1 => {
            if (Object.prototype.hasOwnProperty.call(x1, 'children')) {
              x1.isDisabled = false
              x1.children.forEach(x2 => {
                if (Object.prototype.hasOwnProperty.call(x2, 'children')) {
                  x2.isDisabled = false
                  x2.children.forEach(x3 => {
                    if (Object.prototype.hasOwnProperty.call(x3, 'children')) {
                      x3.isDisabled = false
                    } else {
                      x3.isDisabled = false
                    }
                  })
                } else {
                  x2.isDisabled = false
                }
              })
            } else {
              x1.isDisabled = false
            }
          })
        } else {
          x.isDisabled = false
        }
      })
      this.value = []
      return true
    },
    selected(node, instanceId) {
      console.log('selected')
      if (!Object.prototype.hasOwnProperty.call(node, 'children')) {
        this.options.map(x => {
          x.isDisabled = true
          if (Object.prototype.hasOwnProperty.call(x, 'children')) {
            x.children.forEach(y => {
              y.isDisabled = true
              if (Object.prototype.hasOwnProperty.call(y, 'children')) {
                y.children.forEach(x2 => {
                  x2.isDisabled = true
                  if (Object.prototype.hasOwnProperty.call(x2, 'children')) {
                    x2.children.forEach(y2 => {
                      y2.isDisabled = true
                    })
                  }
                })
              }
            })
          }
        })
      }
      return false
    },
    getValidationsErrors(index, error) {
      return (index + 1) + '. ' + error.label + ': ' + error.msg
    },
    onShown(item) {
      this.formatted = formatDateGRDefault(this.$v.form[item].$model)
      this.selectedDate = formatDateUTCDefault(this.$v.form[item].$model)
      this.$v.form[item].$model = this.formatted
    },
    onHidden(item) {
      if (!isEmpty(this.selectedDate) && this.selectedDate !== '') {
        this.$v.form[item].$model = formatDateGRDefault(this.selectedDate)
      } else {
        this.$v.form[item].$model = formatDateGRDefault(this.formatted)
      }
    },
    onValue(item) {
      return formatDateUTCDefault(this.$v.form[item].$model)
    },
    validDateFormat(value, event) {
      if (value.length === 10) {
        if (!isEmpty(event.explicitOriginalTarget) && !isEmpty(event.explicitOriginalTarget.id)) {
          if (event.explicitOriginalTarget.id !== 'modal-submit')
            if (Object.prototype.hasOwnProperty.call(this.$v.form, event.explicitOriginalTarget.id)) {
              this.$v.form[event.explicitOriginalTarget.id].$model = formatDateWithFormat(value)
            }
        }
      }
      return event.inputType === 'insertText' && (value.length === 2 || (value.length === 5)) ? value + '/' : value
    },

    isEmpty(item) {
      return isEmpty(item)
    },
    keyTransform(key) {
      return key.includes('.') ? key.substring(0, key.indexOf('.')).toString() : key.toString()
    },

    onChange(valid, item) {
      this.isValidState(valid, true)
      if (!isEmpty(item)) {
        let data = item.onChange(valid, this.model)
        if (!isEmpty(data)) {
          if (Object.prototype.hasOwnProperty.call(data, 'fields')) {
            this.model.fields = data.fields
          } else {
            this.model.fields = data
          }
        }
        if (!isEmpty(data)) {
          if (Object.prototype.hasOwnProperty.call(data, 'form')) {
            if (!isEmpty(data.form)) {
              Object.assign(this.model.form, data.form)
            }
          }
        }
      }
      this.setWarningError()
      this.valid()
      this.$emit("handle-change", valid);
    },

    onInput(valid) {
      this.isValidState(valid.$invalid, true)
      this.valid()
      if (this.firstChange) {
        this.$store.dispatch("hasUnsavedChanges", true);
      }
      this.firstChange = false
    },

    validateForm() {
      this.valid()
      this.isValidState(this.$v.form, false)
      const {$dirty, $error} = this.$v.form;
      return $dirty ? !$error : $error;
    },

    validateState(name) {
      try {
        let valid = this.errors.filter(x => x.key === name ? x.key : null)
        if (!isEmpty(valid) && valid.length > 0) {
          return valid[0].validState
        } else {
          return null
        }
      } catch (e) {
        return null
      }
    },
    valid() {
      this.$v.form.$touch()
    },
    showErrorMessageObject(column, label, key) {
      let errors = validationHandler(column)
      if (!isEmpty(errors)) {
        if (!this.hasErrors.find(x => x.key === key)) {
          this.hasErrors = [...this.hasErrors, {key: key, label: label, msg: errors, validState: false}]
        }
      }
    },

    onSubmit() {
      try {
        this.valid()
        if (this.$v.form.$invalid) {
          return {form: this.form, result: false}
        } else {
          return {form: this.form, result: true}
        }
      } catch (e) {
        console.log(e)
      }
    },
    onSave() {
      this.$emit("handle-save");
      try {
        this.valid()
        if (this.$v.form.$invalid) {
          return {form: this.form, result: false}
        } else {
          this.$store.dispatch("hasUnsavedChanges", true);
          return {form: this.form, result: true}
        }
      } catch (e) {
        console.log(e)
      }
    },
    isValidState(valid, isUpdated) {
      let isValid = Object.prototype.hasOwnProperty.call(valid, '$invalid') ? valid.$invalid : valid
      store.dispatch("isValid", {isValid: isValid, isUpdated: isUpdated})
    },
    /*
    * Method for search functionality
    * */
    onSearch() {
      try {
        return {form: this.form, result: this.onValid().result}
      } catch (e) {
        console.log(e)
      }
    },
    onValid() {
      this.hasErrors = []
      this.model.fields.forEach(field => {
        if (field.key !== 'index') {
          this.showErrorMessageObject(this.$v.form[this.keyTransform(field.key)], field.label, field.key)
        }
      })
      let valid = {result: !this.hasErrors.length > 0, errors: this.hasErrors}
      this.isValidState(valid, true)
      if (this.hasErrors.length > 0) {
        if (!isEmpty(this.$refs.alertModal)) {
          this.$refs.alertModal.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
        }
      }
      return valid
    },
    setWarningError() {
      if (!isEmpty(this.model.fields)) {
        this.model.fields.forEach(row => {
          if (Object.prototype.hasOwnProperty.call(row, 'warningMessage')) {
            this.hasWarningError = row.warningMessage
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.required {
  content: "*";
  color: red;
}

.title {
  font-weight: 600;
  font-size: 13px;
}

.subTitle {
  color: #555 !important;
  font-style: italic;
}

.hasHelperError {
  color: red !important;
  font-style: italic;
}

.no-list-style {
  list-style-type: none;
}
</style>